var map = {
	"./lg/about-me-page-part-image.jpg": 3406,
	"./lg/about-me-photo.jpg": 4899,
	"./lg/portfolio-page-part-image.jpg": 6574,
	"./lg/price-list-page-part-image.jpg": 2564,
	"./lg/splashscreen-image.jpg": 4159,
	"./lg/terms-and-conditions-page-part-image.jpg": 3080,
	"./md/about-me-page-part-image.jpg": 7722,
	"./md/about-me-photo.jpg": 9463,
	"./md/portfolio-page-part-image.jpg": 2658,
	"./md/price-list-page-part-image.jpg": 7104,
	"./md/splashscreen-image.jpg": 2851,
	"./md/terms-and-conditions-page-part-image.jpg": 7372,
	"./sm/about-me-page-part-image.jpg": 6771,
	"./sm/about-me-photo.jpg": 9565,
	"./sm/portfolio-page-part-image.jpg": 5601,
	"./sm/price-list-page-part-image.jpg": 209,
	"./sm/splashscreen-image.jpg": 258,
	"./sm/terms-and-conditions-page-part-image.jpg": 3773,
	"./xl/about-me-page-part-image.jpg": 211,
	"./xl/about-me-photo.jpg": 9146,
	"./xl/portfolio-page-part-image.jpg": 2417,
	"./xl/price-list-page-part-image.jpg": 8449,
	"./xl/splashscreen-image.jpg": 7442,
	"./xl/terms-and-conditions-page-part-image.jpg": 9965,
	"./xs/about-me-page-part-image.jpg": 470,
	"./xs/about-me-photo.jpg": 9147,
	"./xs/portfolio-page-part-image.jpg": 9478,
	"./xs/price-list-page-part-image.jpg": 140,
	"./xs/splashscreen-image.jpg": 4407,
	"./xs/terms-and-conditions-page-part-image.jpg": 4880
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9787;